import { TOAST } from '../actionTypes';

const initialState = {
toast:{},
children:null,
childrenData:[]
};

const toastReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case TOAST.HANDLE_TOAST: {
            return {
                ...state,
                toast:actions.payload
            }; 
        }
        case TOAST.HANDLE_CHILDREN: {
            return {
                ...state,
                children:actions.payload
            };
        }
        case TOAST.HANDLE_CHILDREN_DATA: {
            return {
                ...state,
                childrenData:actions.payload
            };
       
        }
        default:
            return state;
    }

};

export default toastReducer;